import { GetStaticPaths, GetStaticProps, GetServerSideProps } from "next";
import { localeMap } from "./util";
import routeStore from "@utils/routeStore";
import _ from "lodash";
export const LANGUAGES = {
  vi: "vi-VN",
  en: "en-US",
  zh: "zh-CN",
  "zh-HK": "zh-HK",
  ko: "ko-KR",
  ja: "ja-JP",
  "en-US": "en",
  "vi-VN": "vi",
  "zh-CN": "zh",
  "ko-KR": "ko",
  "ja-JP": "ja",
};
export const getSlugPaths = (slugs: string[], locale: boolean = true) => {
  if (locale) {
    return _.flatten(
      _.map(localeMap, (instance: any) =>
        _.map(slugs, (slug) => ({
          params: {
            slug: slug,
            locale: instance.get("lang"),
          },
        }))
      )
    );
  }
  return _.flatten(
    _.map(slugs, (slug) => ({
      params: {
        slug: slug,
      },
    }))
  );
};

export const getI18nPaths = () =>
  _.map(localeMap, (instance: any) => {
    return {
      params: {
        locale: instance.get("lang"),
      },
    };
  });

export const getStaticPaths: GetStaticPaths = () => {
  return {
    fallback: false,
    paths: getI18nPaths(),
  };
};
export const getStaticProps: GetStaticProps = ({ params }) => {
  const locale = _.get(params, "locale", "en");
  return {
    props: {
      locale,
    },
  };
};

export const getServer =
  (callback: ({ params }?: any) => Promise<{}>): GetServerSideProps =>
  async ({ params, resolvedUrl, res, ...props }) => {
    res.setHeader(
      "Cache-Control",
      "public, s-maxage=10, stale-while-revalidate=59"
    );
    let locale: any = _.get(params, "locale", "en");
    
    // Validate locale - if it's not in localeMap, return 404
    if (locale && !_.has(localeMap, locale)) {
      return {
        notFound: true,
      };
    }
    
    let mergeProps: any = { locale, resolvedUrl };
    if (_.isFunction(callback)) {
      const _props: { [key: string]: any } = await callback({
        params,
        ...props,
      });
      _.map(_props, (value, key) => {
        if (_.has(_props, key) && _.has(value, locale)) {
          _props[key] = _.get(value, locale);
        }
      });
      routeStore.setHotel(`${_.get(_props, "hotel") || ""}`);
      mergeProps = { ...mergeProps, ..._props };
      if (_.has(mergeProps, "redirect")) {
        return {
          redirect: {
            destination: "/",
            permanent: false,
            ..._.get(mergeProps, "redirect", {}),
          },
        };
      }
      if (_.get(mergeProps, "notFound") === true) {
        return {
          notFound: true,
        };
      }
    }
    delete mergeProps.notFound;
    return {
      props: mergeProps,
    };
  };
